console.log("main.tsx loading...");
import { hydrateRoot, createRoot } from "react-dom/client";
import { Router as WouterRouter } from "wouter";
import { QueryClient, QueryClientProvider, HydrationBoundary } from "@tanstack/react-query";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ClientOnlyToaster } from "@/components/ClientOnlyToaster";
import App from "./App";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000,
      refetchOnWindowFocus: false,
      refetchOnMount: false, // Don't refetch if data is in cache
    },
  },
});

const rootEl = document.getElementById("root")!;

// Get dehydrated state from window
const dehydratedState = (window as any).__REACT_QUERY_STATE__;

const tree = (
  <QueryClientProvider client={queryClient}>
    <HydrationBoundary state={dehydratedState}>
      <WouterRouter>
        <TooltipProvider>
          <App />
          <ClientOnlyToaster />
        </TooltipProvider>
      </WouterRouter>
    </HydrationBoundary>
  </QueryClientProvider>
);

// Reveal root now — by this point Vite has already injected all CSS from
// the `import "./index.css"` above, so the page will be fully styled.
console.log("Mounting app...");

// Check for real SSR content (an actual DOM element, not just the <!--ssr-outlet--> comment).
if (rootEl.firstElementChild !== null) {
  hydrateRoot(rootEl, tree);
} else {
  createRoot(rootEl).render(tree);
}
